(function() {
  const selectors = {
    drawer: '[data-cart-drawer]',
    box: '[data-cart-drawer-box]',
    close: '[data-cart-drawer-close]',
    quantityMinus: '[data-cart-drawer-quantity-minus]',
    quantityPlus: '[data-cart-drawer-quantity-plus]',
    quantityInput: '[data-cart-drawer-quantity-input]',
    productAddForm: 'form[action*="/cart/add"]',
    productGridAtc: '.productitem--action-atc',
    cartLink: 'a[href]',
    headerCount: '.site-header-cart--count',
  };

  const routes = window.Theme?.routes || {};
  const root = window.Shopify?.routes?.root || '/';
  const CART_DRAWER_OPEN_PARAM = 'open_cart_drawer';
  const endpoints = {
    cart: normalizeRoute(routes.cart_url || `${root}cart`),
    add: normalizeRoute('/cart/add.js'),
    change: normalizeRoute(routes.cart_change_url || '/cart/change.js', '.js'),
    cartJson: normalizeRoute('/cart.js'),
    drawerSection: `${root === '/' ? '' : root.replace(/\/$/, '')}/?section_id=cart-drawer`,
  };

  let refreshRequest = null;
  let fetchPatched = false;
  let xhrPatched = false;
  let drawerOpenLock = false;

  function normalizeRoute(path, suffix) {
    let normalized = path || '/';

    if (!normalized.startsWith('/')) {
      normalized = `/${normalized}`;
    }

    if (suffix && !normalized.endsWith(suffix)) {
      normalized = normalized.replace(/\/$/, '') + suffix;
    }

    return normalized;
  }

  function normalizeInternalUrl(url) {
    try {
      return new URL(url, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function isCartPath(pathname) {
    const rootPath = normalizeInternalUrl(root)?.pathname.replace(/\/$/, '') || '';
    const normalizedPath = pathname.replace(/\/$/, '');

    return normalizedPath === '/cart' || normalizedPath === `${rootPath}/cart`;
  }

  function buildDrawerFallbackUrl() {
    const url = new URL(root, window.location.origin);
    const current = new URL(window.location.href);

    current.searchParams.forEach((value, key) => {
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });

    url.searchParams.set(CART_DRAWER_OPEN_PARAM, '1');
    return url.toString();
  }

  function getDrawer() {
    return document.querySelector(selectors.drawer);
  }

  function getBox() {
    return document.querySelector(selectors.box);
  }

  function setLoading(isLoading) {
    const box = getBox();

    if (!box) return;

    box.classList.toggle('cart-drawer-box--loading', isLoading);
  }

  function openCartDrawer() {
    const drawer = getDrawer();

    if (!drawer) return;

    drawer.classList.add('cart-drawer--active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeCartDrawer() {
    const drawer = getDrawer();

    if (!drawer) return;

    drawer.classList.remove('cart-drawer--active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function updateCartItemCounts(count) {
    const normalizedCount = Math.max(0, Number(count) || 0);
    const textValue = normalizedCount > 0 ? String(normalizedCount) : '';

    document.querySelectorAll(selectors.headerCount).forEach((el) => {
      el.setAttribute('data-header-cart-count', textValue);
      el.classList.toggle('visible', normalizedCount > 0);
    });
  }

  async function getCart() {
    const response = await fetch(endpoints.cartJson, {
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Could not fetch cart');
    }

    return response.json();
  }

  async function refreshCartDrawer() {
    const drawer = getDrawer();

    if (!drawer) return null;

    if (refreshRequest) {
      return refreshRequest;
    }

    refreshRequest = fetch(endpoints.drawerSection, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Could not fetch cart drawer section');
        }

        return response.text();
      })
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const updatedDrawer = html.querySelector(selectors.drawer);

        if (!updatedDrawer) {
          throw new Error('Cart drawer section was not found in response');
        }

        drawer.innerHTML = updatedDrawer.innerHTML;
        drawer.dataset.cartUrl = updatedDrawer.dataset.cartUrl || drawer.dataset.cartUrl;
        drawer.dataset.cartChangeUrl = updatedDrawer.dataset.cartChangeUrl || drawer.dataset.cartChangeUrl;

        return drawer;
      })
      .finally(() => {
        refreshRequest = null;
      });

    return refreshRequest;
  }

  async function syncCartState(options = {}) {
    const { open = false, loading = false } = options;

    if (loading) {
      setLoading(true);
    }

    try {
      const cart = await getCart();
      updateCartItemCounts(cart.item_count);
      await refreshCartDrawer();

      if (open) {
        openCartDrawerOnce();
      }

      return cart;
    } catch (error) {
      console.error('Error updating cart drawer:', error);
      throw error;
    } finally {
      if (loading) {
        setLoading(false);
      }
    }
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') {
      return input;
    }

    if (input instanceof URL) {
      return input.href;
    }

    if (typeof Request !== 'undefined' && input instanceof Request) {
      return input.url;
    }

    if (input && typeof input.url === 'string') {
      return input.url;
    }

    return '';
  }

  function isCartAddUrl(url) {
    if (!url) return false;

    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin && parsed.pathname.endsWith('/cart/add.js');
    } catch (error) {
      return String(url).indexOf('/cart/add.js') !== -1;
    }
  }

  function isCartAddRequest(input) {
    return isCartAddUrl(getRequestUrl(input));
  }

  function openCartDrawerOnce() {
    if (drawerOpenLock) return;

    drawerOpenLock = true;
    openCartDrawer();
    window.setTimeout(() => {
      drawerOpenLock = false;
    }, 800);
  }

  function isInternalDrawerRequest(init) {
    const headers = new Headers(init?.headers || {});
    return headers.get('X-Cart-Drawer-Request') === 'true';
  }

  function isInternalDrawerFetchRequest(input, init) {
    if (isInternalDrawerRequest(init)) return true;

    if (typeof Request !== 'undefined' && input instanceof Request) {
      return input.headers.get('X-Cart-Drawer-Request') === 'true';
    }

    return false;
  }

  function syncAfterExternalCartAdd(source) {
    syncCartState({ open: true }).catch((error) => {
      console.warn(`Cart drawer could not refresh after ${source} cart/add.js request:`, error);
    });
  }

  function patchFetch() {
    if (fetchPatched || typeof window.fetch !== 'function') return;

    fetchPatched = true;
    const originalFetch = window.fetch.bind(window);

    window.fetch = async function(input, init) {
      const response = await originalFetch(input, init);

      if (isCartAddRequest(input) && response.ok && !isInternalDrawerFetchRequest(input, init)) {
        syncAfterExternalCartAdd('fetch');
      }

      return response;
    };
  }

  function patchXMLHttpRequest() {
    if (xhrPatched || typeof window.XMLHttpRequest !== 'function') return;

    xhrPatched = true;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalSend = window.XMLHttpRequest.prototype.send;
    const originalSetRequestHeader = window.XMLHttpRequest.prototype.setRequestHeader;

    window.XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this.__cartDrawerRequestUrl = url;
      this.__cartDrawerHeaders = {};
      return originalOpen.call(this, method, url, ...rest);
    };

    window.XMLHttpRequest.prototype.setRequestHeader = function(name, value) {
      if (name) {
        this.__cartDrawerHeaders = this.__cartDrawerHeaders || {};
        this.__cartDrawerHeaders[String(name).toLowerCase()] = String(value);
      }

      return originalSetRequestHeader.call(this, name, value);
    };

    window.XMLHttpRequest.prototype.send = function(...args) {
      this.addEventListener('load', () => {
        const isSuccess = this.status >= 200 && this.status < 300;
        const isDrawerRequest = this.__cartDrawerHeaders?.['x-cart-drawer-request'] === 'true';

        if (isSuccess && isCartAddUrl(this.__cartDrawerRequestUrl) && !isDrawerRequest) {
          syncAfterExternalCartAdd('XHR');
        }
      });

      return originalSend.apply(this, args);
    };
  }

  function hasUsableVariantId(formData) {
    const id = formData.get('id');
    return typeof id === 'string' && id.trim() !== '' && id !== 'not-selected';
  }

  async function addFormToCart(form) {
    const formData = new FormData(form);

    if (!hasUsableVariantId(formData)) {
      console.warn('Cart drawer add-to-cart skipped because no variant id was selected.');
      return false;
    }

    const response = await fetch(endpoints.add, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Cart-Drawer-Request': 'true',
      },
      body: formData,
      credentials: 'same-origin',
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw data;
    }

    await syncCartState({ open: true });
    return true;
  }

  async function addVariantToCart(variantId) {
    if (!variantId) {
      console.warn('Cart drawer add-to-cart skipped because no variant id was available.');
      return false;
    }

    const response = await fetch(endpoints.add, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Cart-Drawer-Request': 'true',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
      credentials: 'same-origin',
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw data;
    }

    await syncCartState({ open: true });
    return true;
  }

  async function changeLineItem(item, quantity) {
    const key = item?.dataset?.lineItemKey;

    if (!key) return;

    setLoading(true);

    try {
      const response = await fetch(endpoints.change, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity,
        }),
        credentials: 'same-origin',
      });

      const cart = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw cart;
      }

      updateCartItemCounts(cart.item_count);
      await refreshCartDrawer();
    } catch (error) {
      console.error('Error updating cart quantity:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  }

  function getQuantityInput(target) {
    const item = target.closest('[data-line-item-key]');
    const input = item?.querySelector(selectors.quantityInput);

    return { item, input };
  }

  function shouldInterceptCartLink(link, event) {
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false;
    }

    if (link.hasAttribute('data-allow-cart-page')) return false;
    if (link.hasAttribute('download')) return false;
    if (link.target && link.target !== '_self') return false;

    try {
      const url = normalizeInternalUrl(link.getAttribute('href'));
      return Boolean(url && url.origin === window.location.origin && isCartPath(url.pathname));
    } catch (error) {
      return false;
    }
  }

  function handleCartDrawerRedirect() {
    const url = new URL(window.location.href);

    if (!window.Shopify?.designMode && isCartPath(url.pathname)) {
      window.location.replace(buildDrawerFallbackUrl());
      return;
    }

    if (url.searchParams.get(CART_DRAWER_OPEN_PARAM) !== '1') return;

    url.searchParams.delete(CART_DRAWER_OPEN_PARAM);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    window.addEventListener('load', () => {
      syncCartState({ open: true }).catch((error) => {
        console.error('Cart drawer could not open after cart redirect:', error);
      });
    });
  }

  document.addEventListener('product-form:cart:navigate', (event) => {
    event.preventDefault();
    syncCartState({ open: true }).catch((error) => {
      console.error('Cart drawer could not open after product form submit:', error);
      window.location.href = endpoints.cart;
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(selectors.productAddForm);

    if (!form) return;
    if (form.closest('product-form')) return;
    if (event.defaultPrevented) return;

    const formData = new FormData(form);

    if (!hasUsableVariantId(formData)) {
      console.warn('Cart drawer let add-to-cart submit continue because no variant id was selected.');
      return;
    }

    event.preventDefault();

    addFormToCart(form).catch((error) => {
      console.error('Error adding product to cart:', error);
    });
  });

  document.addEventListener('click', (event) => {
    const cartLink = event.target.closest(selectors.cartLink);

    if (shouldInterceptCartLink(cartLink, event)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      syncCartState({ open: true }).catch((error) => {
        console.error('Cart drawer could not open from cart link:', error);
        window.location.href = cartLink.href;
      });
    }
  }, true);

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest(selectors.close);

    if (closeButton || event.target === getDrawer()) {
      event.preventDefault();
      closeCartDrawer();
      return;
    }

    const minusButton = event.target.closest(selectors.quantityMinus);
    const plusButton = event.target.closest(selectors.quantityPlus);

    if (minusButton || plusButton) {
      event.preventDefault();

      const { item, input } = getQuantityInput(event.target);
      const currentQuantity = Math.max(0, Number(input?.value) || 0);
      const nextQuantity = minusButton ? Math.max(0, currentQuantity - 1) : currentQuantity + 1;

      if (input) {
        input.value = String(nextQuantity);
      }

      changeLineItem(item, nextQuantity).catch(() => {});
      return;
    }

    if (event.defaultPrevented) return;

    const gridButton = event.target.closest(selectors.productGridAtc);

    if (!gridButton || gridButton.disabled || gridButton.classList.contains('disabled')) return;
    if (gridButton.hasAttribute('data-quickshop-slim')) return;

    const variantId = gridButton.dataset.variantId;

    if (!variantId) {
      console.warn('Cart drawer let grid add-to-cart continue because no variant id was available.');
      return;
    }

    event.preventDefault();
    addVariantToCart(variantId).catch((error) => {
      console.error('Error adding grid product to cart:', error);
    });
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest(selectors.quantityInput);

    if (!input) return;

    const item = input.closest('[data-line-item-key]');
    const nextQuantity = Math.max(0, Number(input.value) || 0);
    input.value = String(nextQuantity);

    changeLineItem(item, nextQuantity).catch(() => {});
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeCartDrawer();
    }
  });

  handleCartDrawerRedirect();
  patchFetch();
  patchXMLHttpRequest();
})();
